__turbopack_context__.v({
  "CatProduct": "c_BsFa_CatProduct",
  "blue": "c_BsFa_blue",
  "blueLight": "c_BsFa_blueLight",
  "containerProdutos": "c_BsFa_containerProdutos",
  "itemProduto": "c_BsFa_itemProduto",
  "purple": "c_BsFa_purple",
  "titleProduct": "c_BsFa_titleProduct",
  "yellow": "c_BsFa_yellow",
});
